import ApiService from '../services/api'
import {
    StickerService,
} from '../services/stickers'


export const ACTIONS = {
    FETCH_STICKER_BALANCE: 'fetchStickerBalance',
    FETCH_STREAM_PREVIEW: 'fetchStreamPreview',
    ADD_STICKER: 'addSticker',
    RESET_WIDGET: 'resetWidget',
    SET_UPDATE_STICKERS: 'setUpdateStickers',
}


export const MUTATIONS = {
    SET_STICKER_LIST: 'setStickerList',
    SET_STREM_PREVIEW: 'setStreamPreview',
    ADD_STICKER: 'addSticker',
    RESET_WIDGET: 'resetWidget',
    SET_UPDATE_STICKERS: 'setUpdateStickers',
}


const state = {
    stickers: [],
    stickersIsLoading: true,
    preview: null,
    previewIsLoading: true,
    widget: [],
}


const getters = {
    stickers: ({ stickers }) => stickers,
    stickersIsLoading: ({ stickersIsLoading }) => stickersIsLoading,
    preview: ({ preview }) => preview,
    previewIsLoading: ({ previewIsLoading }) => previewIsLoading,
    widget: ({ widget }) => widget,
}


const actions = {
    [ACTIONS.FETCH_STICKER_BALANCE]({ commit }) {
        const userId = window.streamer_user_id

        ApiService.setHeaderAuth()
        ApiService.setHeaderLang()
        return StickerService.getStickerBalance(userId)
            .then(({ data }) => {
                commit(MUTATIONS.SET_STICKER_LIST, data)
            })
            .catch(error => {
                throw new Error(error)
            })
    },

    [ACTIONS.ADD_STICKER]({ commit }, sticker) {
        commit(MUTATIONS.ADD_STICKER, sticker)
    },

    [ACTIONS.FETCH_STREAM_PREVIEW]({ commit }) {
        const userId = window.streamer_user_id

        ApiService.setHeaderAuth()
        return StickerService.getStreamPreview(userId)
            .then(({ data }) => {
                commit(MUTATIONS.SET_STREM_PREVIEW, data)
            })
            .catch(error => {
                console.error(error)

                // stub
                commit(MUTATIONS.SET_STREM_PREVIEW, {data: {platforms: [{}]}})
            })
    },

    [ACTIONS.RESET_WIDGET]({ commit }) {
        commit(MUTATIONS.RESET_WIDGET)
    },

    [ACTIONS.SET_UPDATE_STICKERS]({ commit }, id) {
        commit(MUTATIONS.SET_UPDATE_STICKERS, id)
    },
}


const mutations = {
    [MUTATIONS.SET_STICKER_LIST](state, { data }) {
        state.stickers = [...data]
        state.stickersIsLoading = false
    },

    [MUTATIONS.ADD_STICKER](state, { sticker, opt = {} }) {
        const rnd = (min, max) => Math.round(min - 0.5 + Math.random() * (max - min + 1))

        state.widget.push({
            _id: '' + Date.now() + Math.round(Math.random() * 1 * 100000),
            isActive: false,
            top: opt.top || rnd(10, 90),
            left: opt.left || rnd(10, 90),
            angle: opt.angle || rnd(-45, 45),
            scale: opt.scale || Math.round((.5 + Math.random() * (1.5 - .5)) * 10) / 10,
            ...sticker,
        })
    },

    [MUTATIONS.SET_STREM_PREVIEW](state, { data }) {
        if (!data.platforms || data.platforms.length === 0) {
            state.preview = []
        } else {
            state.preview = data.platforms[0]
        }

        state.previewIsLoading = false
    },

    [MUTATIONS.RESET_WIDGET](state) {
        state.widget = []
    },

    [MUTATIONS.SET_UPDATE_STICKERS](state, id) {
        state.widget = state.widget.filter(s => s._id !== id)
    },
}


export default {
    state,
    getters,
    actions,
    mutations,
}